"use strict";
var Observable_1 = require('../../Observable');
var retry_1 = require('../../operator/retry');
Observable_1.Observable.prototype.retry = retry_1.retry;
//# sourceMappingURL=retry.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/retry.js
 ** module id = 1508
 ** module chunks = 2
 **/